// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconCartFilled(Props) {
  var sizeOpt = Props.size;
  var className = Props.className;
  var size = sizeOpt !== undefined ? sizeOpt : 24;
  var tmp = {
    height: size.toString(),
    width: size.toString(),
    fill: "none",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    clipRule: "evenodd",
    d: "M100 33.3334C95.5797 33.3334 91.3405 35.0893 88.2149 38.2149C85.0893 41.3405 83.3333 45.5797 83.3333 50V58.3309L116.667 58.3361V50C116.667 45.5797 114.911 41.3405 111.785 38.2149C108.66 35.0893 104.42 33.3334 100 33.3334ZM133.333 58.3387V50C133.333 41.1595 129.821 32.681 123.57 26.4298C117.319 20.1786 108.841 16.6667 100 16.6667C91.1594 16.6667 82.681 20.1786 76.4298 26.4298C70.1786 32.681 66.6667 41.1595 66.6667 50V58.3284L52.976 58.3262L52.976 58.3361C52.904 58.3343 52.8318 58.3334 52.7593 58.3333C49.1547 58.3329 45.5927 59.112 42.3174 60.6171C39.0421 62.1222 36.131 64.3178 33.7836 67.0534C31.4363 69.7889 29.7084 72.9998 28.7181 76.4657C27.7279 79.9316 27.4989 83.5706 28.0468 87.1333L38.5054 155.068C39.7159 162.937 43.703 170.113 49.7455 175.298C55.7883 180.483 63.4878 183.333 71.45 183.333H128.55C136.513 183.335 144.214 180.486 150.259 175.301C156.303 170.117 160.292 162.939 161.503 155.068L161.503 155.067L171.961 87.1347L171.961 87.1333C172.509 83.5706 172.28 79.9316 171.29 76.4657C170.3 72.9998 168.572 69.7889 166.225 67.0534C163.877 64.3178 160.966 62.1222 157.691 60.6171C154.646 59.2179 151.353 58.4461 148.009 58.3448V58.341L147.868 58.3409C147.662 58.3358 147.455 58.3333 147.249 58.3333C147.13 58.3334 147.012 58.3359 146.895 58.3408L133.333 58.3387ZM133.333 75.0087L116.667 75.0061V91.6667C116.667 96.2691 120.398 100 125 100C129.602 100 133.333 96.2691 133.333 91.6667V75.0087ZM66.6667 74.9984L83.3333 75.0009V91.6667C83.3333 96.2691 79.6024 100 75 100C70.3976 100 66.6667 96.2691 66.6667 91.6667V74.9984Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}
IconCartFilled.displayName = "IconCartFilled";
var make = IconCartFilled;
export { make };
/* react Not a pure module */